import { initializeProductComparison } from './product-comparison.js';

window.addEventListener('load', function() {
  addEquipmentButtonEvent(document);
  initializeModellPage();

  window.initializeModellPage = initializeModellPage;
});

function initializeModellPage() {
  loadTopsellerPrices();
  addFavoriteEvents();
  addNewBatteryEvents();
  addDetailSwitchEvents();
  initializeProductComparison();
}

/**
 * On mobile initially only two items are shown
 * When clicking the button all items are shown and this button is hidden
 *
 * @param {HTMLElement|Document} area
 */
async function addEquipmentButtonEvent(area) {
  const showAllEquipmentButtons = area.querySelectorAll('.js_show_all_equipment');

  showAllEquipmentButtons.forEach(function(showAllEquipmentButton) {
    const parent = showAllEquipmentButton.parentElement;

    showAllEquipmentButton.addEventListener('click', function() {
      parent.querySelectorAll('.js_buybox_equipment_item.hidden_on_mobile').forEach(function(el) {
        el.classList.remove('hidden_on_mobile');
      });
      showAllEquipmentButton.style.display = 'none';
    });
  });
}

/**
 * We only show the topseller prices for the first tiles on the initial load,
 * because we don't want to load all prices at once.
 *
 * This function loads the missing prices and inserts them in the tiles.
 */
async function loadTopsellerPrices() {
  const hashedArticleTypeIds = [];
  const topsellerTilesWithoutPrice = document.querySelectorAll('.js_topseller_tile:not(.js_has_price)');
  topsellerTilesWithoutPrice.forEach(function(topsellerTile) {
    hashedArticleTypeIds.push(topsellerTile.dataset.hashedArticleTypeId);
  });

  const formData = new FormData();
  formData.append('hashedArticleTypeIds', JSON.stringify(hashedArticleTypeIds));
  fetch('/shopController.php?objective=loadTopsellerPrices', {
    method: 'post',
    body: formData,
    headers: {'X-CSRF-Token': fetchCsrfToken()},
  }).then((response) => {
    response.json().then((formattedPrices) => {
      topsellerTilesWithoutPrice.forEach(function(topsellerTile) {
        const hashedArticleTypeId = parseInt(topsellerTile.dataset.hashedArticleTypeId);
        if (hashedArticleTypeId in formattedPrices) {
          const formattedPrice = formattedPrices[hashedArticleTypeId];
          const priceElement = topsellerTile.querySelector('.js_topseller_price');
          priceElement.innerHTML = 'ab <span class="h5 m_0">' + formattedPrice.price + '</span>';
          topsellerTile.href = formattedPrice.link;
          topsellerTile.classList.add('js_has_price');
        }
      });
    });
  });
}

async function addFavoriteEvents() {
  const addFavoriteButtons = document.querySelectorAll('.js_add_favorite');
  const removeFavoriteButtons = document.querySelectorAll('.js_remove_favorite');
  const favoriteText = document.querySelector('.js_favorite_text');
  if (!favoriteText) {
    return;
  }

  addFavoriteButtons.forEach((addFavoriteButton) => {
    addFavoriteButton.addEventListener('click', () => {
      addFavorite(addFavoriteButtons, removeFavoriteButtons, favoriteText);
    });
  });

  removeFavoriteButtons.forEach((removeFavoriteButton) => {
    removeFavoriteButton.addEventListener('click', () => {
      removeFavorite(removeFavoriteButton.dataset.vm, addFavoriteButtons, removeFavoriteButtons, favoriteText);
    });
  });
}

/**
 * Adds the current article type as a favorite.
 *
 * @param {HTMLElement[]} addFavoriteButtons
 * @param {HTMLElement[]} removeFavoriteButtons
 * @param {HTMLElement} favoriteText
 */
function addFavorite(addFavoriteButtons, removeFavoriteButtons, favoriteText) {
  $('#wait-mask').stop().fadeIn();
  let filter = {};
  document.querySelectorAll('.button_modellfilter.active:not(.button_modellfilter_zustand)').forEach(function(el) {
    filter[el.dataset.filterId] = [el.dataset.filterValue];
  });
  doAjaxCall(
      '/shopController.php?objective=saveFavorite',
      {article_type_id: atId, filter: filter, return_html: false},
      (res) => {
        $('#wait-mask').stop().fadeOut();
        if (res.success) {
          favoriteText.innerHTML = 'Erfolgreich gespeichert!';
          addFavoriteButtons.forEach((addFavoriteButton) => {
            addFavoriteButton.style.display = 'none';
          });
          removeFavoriteButtons.forEach((removeFavoriteButton) => {
            removeFavoriteButton.style.display = 'inline-flex';
            removeFavoriteButton.dataset.vm = res.vm;
          });
        } else {
          favoriteText.innerHTML = res.error;
        }
      }
  );
}

/**
 * Removes the given favorite id as a favorite.
 *
 * @param {number} favoriteId
 * @param {HTMLElement[]} addFavoriteButtons
 * @param {HTMLElement[]} removeFavoriteButtons
 * @param {HTMLElement} favoriteText
 */
function removeFavorite(favoriteId, addFavoriteButtons, removeFavoriteButtons, favoriteText) {
  $('#wait-mask').stop().fadeIn();
  doAjaxCall(
      '/shopController.php?objective=delvormerkung',
      {id: favoriteId},
      (res) => {
        $('#wait-mask').stop().fadeOut();
        if (res.success) {
          favoriteText.innerHTML = 'Erfolgreich entfernt!';
          addFavoriteButtons.forEach((addFavoriteButton) => {
            addFavoriteButton.style.display = 'inline-flex';
          });
          removeFavoriteButtons.forEach((removeFavoriteButton) => {
            removeFavoriteButton.style.display = 'none';
          });
        }
      }
  );
}

async function addNewBatteryEvents() {
  const url = new URL(location.href);

  const addBatteryButton = document.querySelector('.js_add_new_battery');
  if (addBatteryButton) {
    addBatteryButton.addEventListener('click', function() {
      $('#wait-mask').stop().fadeIn();
      url.searchParams.set('new-battery', '1');
      historyManager.load(url.search);
    });
  }

  const removeBatteryButton = document.querySelector('.js_remove_new_battery');
  if (removeBatteryButton) {
    removeBatteryButton.addEventListener('click', function() {
      $('#wait-mask').stop().fadeIn();
      url.searchParams.delete('new-battery');
      historyManager.load(url.search);
    });
  }
}

async function addDetailSwitchEvents() {
  const switchButtons = document.querySelectorAll('.js_product_details_switch_button');

  if (switchButtons.length > 0) {
    switchButtons[0].classList.add('active');
  }

  switchButtons.forEach((switchButton) => {
    switchButton.addEventListener('click', function() {
      switchButtons.forEach(function(button) {
        button.classList.remove('active');
      });
      switchButton.classList.add('active');
      const contentElement = document.getElementById(switchButton.dataset.content);
      document.querySelectorAll('.js_product_details_content').forEach(function(content) {
        content.classList.remove('active');
      });
      contentElement.classList.add('active');
      document.querySelector('.js_product_details_scroll_anchor').scrollIntoView({behavior: 'smooth'});
    });
  });
}